function submitAddress(form) {
    $('#deliveryAddressVerificationModal').modal('hide');
    $('body').removeClass('modal-open').css('padding', '0');

    const $submitButton = form.find('.js-submit-address');
    $submitButton.addClass('js-address-verified');
    $submitButton.trigger('click');
}

function fillModalElement(verifyAddressUrl, form, addressFormData, addressInputName) {
    const modifiedFormData = addressFormData;

    const params = {
        firstName: $(`input[name$="${addressInputName}_firstName"]`).val(),
        lastName: $(`input[name$="${addressInputName}_lastName"]`).val(),
        address1: $(`input[name$="${addressInputName}_address1"]`).val(),
        city: $(`input[name$="${addressInputName}_city"]`).val(),
        state: $(`select[name$="${addressInputName}_states_stateCode"]`).val(),
        zipCode: $(`input[name$="${addressInputName}_postalCode"]`).val(),
        countryCode: $(`select[name$="${addressInputName}_country"]`).val(),
    };
    $.ajax({
        url: verifyAddressUrl,
        method: 'POST',
        dataType: 'json',
        data: modifiedFormData,
        success: (data) => {
            $.spinner().stop();
            if (data.addressSuggestion) {
                const $modal = $('#deliveryAddressVerificationModal');
                $modal.modal('show');

                // original Address
                const davmodalOriginalAdd = $('#deliveryAddressVerificationModal .originalAddress');
                $(davmodalOriginalAdd).find('p.name').text(`${params.firstName} ${params.lastName}`);
                $(davmodalOriginalAdd).find('p.address-one').text(params.address1);
                $(davmodalOriginalAdd).find('span.city').text(params.city);
                $(davmodalOriginalAdd).find('span.state').text(params.state);
                $(davmodalOriginalAdd).find('span.zipCode').text(params.zipCode);

                // standard Address
                const davmodalStandardAdd = $('#deliveryAddressVerificationModal .standardAddress');
                $(davmodalStandardAdd).find('p.name').text(`${params.firstName} ${params.lastName}`);
                $(davmodalStandardAdd).find('p.address-one').text(data.addressSuggestion.address1);
                $(davmodalStandardAdd).find('span.city').text(data.addressSuggestion.city);
                $(davmodalStandardAdd).find('span.state').text(data.addressSuggestion.stateCode);
                $(davmodalStandardAdd).find('span.zipCode').text((data.addressSuggestion.postalCode).substr(0, 5));
            } else {
                submitAddress(form);
            }

            $('#deliveryAddressVerificationModal .modal-header .close').on('click', (e) => {
                e.preventDefault();
                $('body').trigger('checkout:enableButton', '.next-step-button button');
            });

            $('#deliveryAddressVerificationModal').on('hidden.bs.modal', () => {
                $('body').trigger('checkout:enableButton', '.next-step-button button');
            });

            $('#deliveryAddressVerificationModal').find('.useThisAddress').off('click').on('click', () => {
                if ($('#standardAddressRadio').is(':checked')) {
                    $(`input[name$="${addressInputName}_address1"]`).val(data.addressSuggestion.address1);
                    $(`input[name$="${addressInputName}_city"]`).val(data.addressSuggestion.city);
                    $(`select[name$="${addressInputName}_states_stateCode"]`).val(data.addressSuggestion.stateCode);
                    $(`input[name$="${addressInputName}_postalCode"]`).val(data.addressSuggestion.postalCode);
                    $(`select[name$="${addressInputName}_country"]`).val(data.addressSuggestion.countryCode);
                }
                submitAddress(form);
            });
        },
        error: () => {
            $.spinner().stop();
        },
    });
}

$('.js-address-box-list input[type="radio"]').on('click', (e) => {
    const $this = $(e.currentTarget);

    $('.js-address-box-list').removeClass('checked');
    $this.closest('.js-address-box-list').addClass('checked');
});

function verifyAddress(verifyAddressUrl, form, addressFormData, addressInputName) {
    fillModalElement(verifyAddressUrl, form, addressFormData, addressInputName);
}

module.exports.verifyAddress = verifyAddress;
